import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4700105b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-area flex gap-2 justify-center mb-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputArea',
  props: {
    isDisabled: { type: Boolean }
  },
  emits: ['submit'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const currentInput = ref('');

const inputElement = ref<HTMLInputElement | null>(null);

const onInput = (event: Event) => {
  // Logique supplémentaire si nécessaire
};

const submitWord = () => {
  emits('submit', currentInput.value.toUpperCase());
  currentInput.value = ''; // Réinitialise l'entrée

  // Remet le focus dans l'input
  if (inputElement.value) {
    inputElement.value.focus();
  }
};

// Réagit aux changements de l'entrée si nécessaire
watch(currentInput, (newValue) => {
  // Logique supplémentaire si nécessaire
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "inputElement",
      ref: inputElement,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentInput).value = $event)),
      type: "text",
      disabled: _ctx.isDisabled,
      class: "input-field border border-gray-300 rounded p-2",
      placeholder: "Entrez un mot...",
      maxlength: "6",
      onInput: onInput,
      onKeyup: _withKeys(submitWord, ["enter"])
    }, null, 40, _hoisted_2), [
      [_vModelText, currentInput.value]
    ]),
    _createElementVNode("button", {
      disabled: _ctx.isDisabled,
      class: "submit-button bg-blue-600 text-white rounded p-2",
      onClick: submitWord
    }, " Soumettre ", 8, _hoisted_3)
  ]))
}
}

})